import React, { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import LangSwithcher from "../../components/helpers/LangSwithcher";
import { useTranslation } from "react-i18next";


const AccountSuccess = () => {
    const {t,i18n} = useTranslation();
    const navigate = useNavigate();

    const goToLogin = () => {
        window.localStorage.removeItem('token');
        window.localStorage.removeItem('b-user');
        navigate(`/${i18n.language}/login`);
    }

    useEffect(()=>{
      setTimeout(()=>{
        navigate(`/${i18n.language}/login`);
      },5000);
    },[])

    return (
        <>
        <div className="absolute w-[calc(100%-48px)] top-[24px] start-[24px] flex flex-nowrap">
            <div className="w-[50%] h-[47px]">
              <Link to="/"><img src="/assets/images/logo-normal.svg" className="w-[128px] h-[47px]" alt="" /></Link>
            </div>
            <div className="w-[50%] h-[47px] text-end">
              {/* <LangSwithcher style="auth" /> */}
            </div>
          </div>
          <div className="pt-[25vh] pb-[50px] text-center h-full min-h-[100vh]">
            <div className="rounded-[16px] bg-white mx-auto my-[15px] w-[calc(100%-30px)] max-w-[911px] p-[5px] text-center">
                <img src="/assets/images/success.svg" alt="" className="inline-block mt-[30px] mb-[20px]" />
                <h3 className="text-grey-900 text-[40px] font-[600] leading-[74px] mb-0">{t('registerSuccess.congratulations')}</h3>
                <p className="text-grey-900 text-[28px] font-[500] leading-[51px] mb-[15px]">{t('registerSuccess.message')}</p>
                <p className="text-grey-900 text-[24px] font-[500] leading-[36px] mb-[25px]">لقد تم الدفع بنجاح</p>
                <p className="text-grey-900 text-[24px] font-[500] leading-[36px] mb-[25px]">سيتم تحويلك تلقائيًا خلال 5 ثوانٍ. إذا لم يتم تحويلك، من فضلك ,<span className="text-blue underline cursor-pointer select-none" onClick={()=>goToLogin()}>اضغط هنا.</span></p>
                .
            </div>
          </div>
        </>
    )
}

export default AccountSuccess;
